export default {
  title: '学校管理',
  menu: '学校管理',
  label: {
    schoolChineseName: '学校中文名称',
    schoolEnglishName: '学校英文名称',
    reviewStatus: '审核状态',
    edit: '编辑',
    addSchool: '新增学校',
    editSchool: '编辑学校',
    mergeTo: '合并到'
  },
  reviewStatus: {
    yes: '已审核',
    no: '未审核'
  },
  placeholder: {
    keywords: '按照学校中文名称搜索',
    pleaseStartTyping: '请开始输入'
  },
  message: {
    saveSuccess: '保存成功',
    saveFail: '保存失败'
  }
}
